import React, { memo, useCallback } from 'react';
import { Select } from 'antd';
import { indexes } from './config';
import { useKeepExistingIds } from './hooks/useKeepExistingIds';
import BaseSelect from './BaseSelect';
import OptGroupLabel from './OptGroupLabel';
import styles from './index.module.scss';

const typeNameToId = {
  house: 1,
  porch: 2,
};
const typeIdExceptions = [typeNameToId.house, typeNameToId.porch];

const SelectRooms = ({
  options,
  ids,
  value,
  propsRef,
  loading,
  notFoundContent,
  map,
}) => {
  const onChange = useCallback(
    (ids) => {
      const { value, onChange: changeHandler } = propsRef.current;
      changeHandler([value[indexes.street], value[indexes.house], ids]);
    },
    [propsRef]
  );

  useKeepExistingIds({ propsRef, index: indexes.room, loading, ids, onChange });

  return (
    <BaseSelect
      loading={loading}
      placeholder="Помещения"
      value={value}
      onChange={onChange}
      notFoundContent={notFoundContent}
      optionLabelProp="label"
    >
      {Object.entries(options || {}).map(({ 0: entityId, 1: items }) => {
        const { streetName, houseName, houseType } = map?.get(entityId) || {};
        const entityName = join(', ', streetName, houseName);

        return (
          <Select.OptGroup
            key={entityId}
            label={<OptGroupLabel>{streetName || ''}</OptGroupLabel>}
          >
            <Select.OptGroup
              label={
                <OptGroupLabel nested>
                  ● {join(' ', houseName, houseType ? `(${houseType})` : '')}
                </OptGroupLabel>
              }
            >
              {items.map((item) => {
                const content = typeIdExceptions.includes(item.typeId)
                  ? item.name
                  : `${item.typeShortName} ${item.name}`;

                return (
                  <Select.Option
                    key={item.id}
                    searchtext={`${entityName}${houseType}${item.name}`}
                    value={item.id}
                    label={
                      <OptionLabel
                        entityName={entityName}
                        content={content}
                      />
                    }
                  >
                    {content}
                  </Select.Option>
                );
              })}
            </Select.OptGroup>
          </Select.OptGroup>
        );
      })}
    </BaseSelect>
  );
};

export default memo(SelectRooms);

function OptionLabel({ entityName, content }) {
  return (
    <>
      <div className={styles.accent}>{entityName}</div>
      {content}
    </>
  );
}

function join(separator, ...args) {
  return args.filter(Boolean).join(separator);
}
